import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton, InputAdornment } from '@mui/material';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';

import AppButton from '../../../components/designe/app-button/AppButton';
import AppFormTextField from '../../../components/designe/app-form-text-field';
import theme from '../../../styles/theme';
import { useStyles } from './ChangePassword.styles';
import { useChangePasswordComponent } from './useChangePasswordComponent';

export function ChangePassword() {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const { formik, showPassword, setShowPassword } =
    useChangePasswordComponent();

  return (
    <div className={classes.changePasswordWrapper}>
      <form
        onSubmit={formik.handleSubmit}
        className={classes.changePasswordForm}>
        <AppFormTextField
          label={t('settings.currentPassword')}
          fullWidth
          name="currentPassword"
          type={showPassword ? 'text' : 'password'}
          className={classes.textField}
          formik={formik}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  size="large">
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <AppFormTextField
          label={t('settings.password')}
          fullWidth
          name="password"
          type={showPassword ? 'text' : 'password'}
          className={classes.textField}
          formik={formik}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  size="large">
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <AppFormTextField
          label={t('settings.confirmPassword')}
          fullWidth
          name="confirmPassword"
          type={showPassword ? 'text' : 'password'}
          className={classes.textField}
          formik={formik}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  size="large">
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <div className={classes.buttonWrapper}>
          <AppButton disabled={!formik.isValid} type="submit">
            {t('settings.changePassword')}
          </AppButton>
        </div>
      </form>
    </div>
  );
}
